import Loading from '-!react-svg-loader!./images/loading.svg'
import HeartRate from '-!react-svg-loader!./images/heartrate.svg'
import Muscle from '-!react-svg-loader!./images/muscle.svg'
import Status0 from '-!react-svg-loader!./images/status0.svg'
import Status1 from '-!react-svg-loader!./images/status1.svg'
import Status2 from '-!react-svg-loader!./images/status2.svg'
import Status3 from '-!react-svg-loader!./images/status3.svg'
import Status4 from '-!react-svg-loader!./images/status4.svg'
import User from '-!react-svg-loader!./images/user.svg'
import Share from '-!react-svg-loader!./images/share.svg'
import QAoperator from '-!react-svg-loader!./images/qacom.svg'
import QApatient from '-!react-svg-loader!./images/qauser.svg'

export default {
  Loading,
  HeartRate,
  Muscle,
  Status0,
  Status1,
  Status2,
  Status3,
  Status4,
  User,
  Share,
  QAoperator,
  QApatient,
}



// WEBPACK FOOTER //
// ./src/components/atoms/iconStroke/icon-svgs.tsx